import { Locale } from 'src/replicant/ruleset/locale';
import {
  tryLocalStorage,
  tryToSetItemToLocalStorage,
} from '../tryLocalStorage';

/** Where the locale resolved by the previous launch is remembered. */
const LOCALE_HINT_KEY = 'buruburu.localeHint';

/**
 * The locale this device resolved last launch, if any. The authoritative
 * locale lives in Replicant state, so before the handshake this is the best
 * guess: the browser language disagrees with it for anyone whose in-game
 * language differs from their device language.
 */
export function readLocaleHint(): Locale | null {
  const hint = tryLocalStorage()?.getItem(LOCALE_HINT_KEY);
  return hint ? (hint as Locale) : null;
}

export function writeLocaleHint(locale: Locale): void {
  tryToSetItemToLocalStorage(LOCALE_HINT_KEY, locale);
}
